module.exports = __webpack_public_path__ + "img/images.35d44aaf.svg";